import LDescription from './src/main'

/* istanbul ignore next */
LDescription.install = function(Vue) {
  Vue.component(LDescription.name, LDescription)
}

export default LDescription
